import img1 from 'src/assets/images/about/activity.avif';
import img2 from "src/assets/images/services/2.avif";
import img3 from "src/assets/images/services/3.avif";
import img4 from "src/assets/images/services/4.avif";
import img5 from "src/assets/images/services/5.avif";
import img6 from "src/assets/images/services/6.avif";


export type ServiceCardType = {
    title: {
        [key: string]: string
    },
    img: string,
    id: string
}

const data: ServiceCardType[] = [
    {
        title: {
            ar: "صيانة المحركات",
            en: "Engine Maintenance"
        },
        img: img1,
        id: "engine_maintenance_0"
    },
    {
        title: {
            ar: "صيانة الكمبيوات",
            en: "Gearbox Maintenance"
        },
        img:img2,
        id: "gearbox_maintenance_1"
    },
    {
        title: {
            ar: "صيانة الصالة",
            en: "Chassis Maintenance"
        },
        img: img3,
        id: "chassis_maintenance_2"
    },
    {
        title: {
            ar: "صيانة الفرامل",
            en: "Brake Maintenance"
        },
        img: img4,
        id: "brake_maintenance_3"
    },
    {
        title: {
            ar: "صيانة الهواء",
            en: "Air System Maintenance"
        },
        img:img5,
        id: "air_system_maintenance_4"
    },
    {
        title: {
            ar: "صيانة الهيدروليك",
            en: "Hydraulic Maintenance"
        },
        img: img6,
        id: "hydraulic_maintenance_5"
    }
  
]

export default data;
